import React from "react";
import Wrapper from "./style";

const BaseLayout = ({ children }) => {
  return <Wrapper>{children}</Wrapper>;
};

export default BaseLayout;
